import { createTheme } from "@mui/material/styles";

const hqTheme = createTheme({
	typography: {
		htmlFontSize: 10,
		fontFamily: '"Noto Sans TC", sans-serif',
		h1: { fontSize: "5.5rem", lineHeight: 1.2, fontWeight: 500 },
		h2: { fontSize: "4.5rem", lineHeight: 1.167, fontWeight: 500 },
		h3: { fontSize: "3.4rem", lineHeight: 1.235, fontWeight: 500 },
		h4: { fontSize: "2.5rem", lineHeight: 1.334, fontWeight: 500 },
		h5: { fontSize: "2.0rem", lineHeight: 1.6, fontWeight: 500 },
		h6: { fontSize: "1.7rem", lineHeight: 1.6, fontWeight: 500 },
		subtitle1: { fontSize: "1.7rem", lineHeight: 1.75, fontWeight: 400 },
		subtitle2: { fontSize: "1.4rem", lineHeight: 1.57, fontWeight: 500 },
		body1: { fontSize: "1.7rem", lineHeight: 1.5, fontWeight: 400 },
		body2: { fontSize: "1.4rem", lineHeight: 1.43, fontWeight: 400 },
		button: { fontSize: "1.4rem", lineHeight: 1.75, fontWeight: 500 },
		caption: { fontSize: "1.2rem", lineHeight: 1.66, fontWeight: 400 },
	},
	palette: {
		mode: "dark",
		primary: {
			main: "#EDAA54",
			dark: "#937312",
			light: "#f8d774",
		},
		secondary: {
			main: "#429e9d",
			dark: "#275e5e",
			light: "#89c2c2",
		},
		background: {
			default: "#363636",
			paper: "#2a2b2d",
		},
		text: {
			primary: "#fefefe",
			secondary: "#e5e5e5",
			disabled: "rgba(255, 255, 255, 0.5)",
		},
		divider: "rgba(255, 255, 255, 0.2)",
		action: {
			active: "rgba(255, 255, 255, 0.54)",
			hover: "rgba(255, 255, 255, 0.06)",
			selected: "rgba(255, 255, 255, 0.08)",
			disabled: "rgba(255, 255, 255, 0.26)",
			disabledBackground: "rgba(255, 255, 255, 0.05)",
			focus: "rgba(255, 255, 255, 0.12)",
		},
	},
	components: {
		MuiDialog: {
			styleOverrides: {
				paper: {
					backgroundColor: "#2a2b2d",
					backgroundImage: "none",
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					backgroundImage: "none",
				},
			},
		},
		MuiDialogContent: {
			styleOverrides: {
				root: {
					backgroundColor: "#2a2b2d",
					color: "#fefefe",
				},
			},
		},
		MuiSvgIcon: {
			styleOverrides: {
				root: {
					color: "#e5e5e5",
				},
			},
		},
		MuiCssBaseline: {
			styleOverrides: {
				".inputbase-root": {
					color: "#fefefe",
					backgroundColor: "#2a2b2d",
				},
				".inputbase-root .svg-icon-root, .inputbase-root .MuiSvgIcon-root": {
					color: "#e5e5e5",
				},
				".inputbase-input": {
					color: "#fefefe",
				},
				".inputbase-input::placeholder": {
					color: "#9e9e9e",
					opacity: 1,
				},
			},
		},
	},
});

export default hqTheme;
